'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    navDrawerClassNames: function() {
        return navDrawerClassNames;
    },
    useNavDrawerStyles_unstable: function() {
        return useNavDrawerStyles_unstable;
    }
});
const _react = require("@griffel/react");
const navDrawerClassNames = {
    root: 'fui-NavDrawer'
};
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        De3pzq: "f1ctqxl6",
        Bt984gj: "f3gca8"
    },
    defaultWidth: {
        a9b677: "f12j6lm0"
    }
}, {
    d: [
        ".f1ctqxl6{background-color:var(--colorNeutralBackground4);}",
        ".f3gca8{align-items:unset;}",
        ".f12j6lm0{width:260px;}"
    ]
});
const useNavDrawerStyles_unstable = (state)=>{
    'use no memo';
    const { size } = state;
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(navDrawerClassNames.root, styles.root, !size && styles.defaultWidth, state.root.className);
    return state;
};
